module.exports = __webpack_public_path__ + "img/temperature.22410dc.svg";